import { useContext } from 'react';
import { PartnerContext, type PartnerContextValue } from './PartnerContext';

export function usePartner(): PartnerContextValue {
  const value = useContext(PartnerContext);
  if (!value) {
    throw new Error('usePartner must be used inside the Partner Portal.');
  }

  return value;
}
